var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "tag"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1751_30289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1751_30289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "tag_2",
    d: "M7.00016 23.3346L8.16683 18.668H4.0835L4.66683 16.3346H8.75016L9.91683 11.668H5.25016L5.8335 9.33464H10.5002L11.6668 4.66797H14.0002L12.8335 9.33464H17.5002L18.6668 4.66797H21.0002L19.8335 9.33464H23.9168L23.3335 11.668H19.2502L18.0835 16.3346H22.7502L22.1668 18.668H17.5002L16.3335 23.3346H14.0002L15.1668 18.668H10.5002L9.3335 23.3346H7.00016ZM11.0835 16.3346H15.7502L16.9168 11.668H12.2502L11.0835 16.3346Z",
    fill: "#484D63"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTag);
export default __webpack_public_path__ + "static/media/icon_tag.03c090492793cadba8646ec8de1effa8.svg";
export { ForwardRef as ReactComponent };